import { ApplicationConfig, importProvidersFrom, Provider, ENVIRONMENT_INITIALIZER, inject } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { APP_ROUTES } from './app.routes';
import { BrowserModule, Title } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_ENV_CONFIG, getEnvironment } from './shared/services';
import { FormlyModule } from '@ngx-formly/core';
import {
  RktFormFieldWrapperComponent,
  RktFormInputComponent,
  RktFormInputPasswordComponent,
  RktFormlyFieldGroupComponent,
} from '@rocketfinancialcorp/rocket-ui/form';
import { RktIconRegistryService, search, aggregation, link, checkboxOff, checkboxOn } from '@rocketfinancialcorp/rocket-ui/icon';
import { provideEnvironmentNgxMask } from 'ngx-mask';

export const iconsProvider: () => Provider = () => {
  return {
    provide: ENVIRONMENT_INITIALIZER,
    multi: true,
    useValue: () => inject(RktIconRegistryService).registerIcons([search, aggregation, link, checkboxOff, checkboxOn]),
  };
};

export const appConfig: ApplicationConfig = {
  providers: [
    Title,
    importProvidersFrom(
      BrowserModule,
      FormlyModule.forRoot({
        types: [
          { name: 'formly-group', component: RktFormlyFieldGroupComponent },
          { name: 'input', component: RktFormInputComponent, wrappers: ['field-wrapper'] },
          { name: 'input-password', component: RktFormInputPasswordComponent, wrappers: ['field-wrapper'] },
        ],
        wrappers: [{ name: 'field-wrapper', component: RktFormFieldWrapperComponent }],
      }),
    ),
    { provide: APP_ENV_CONFIG, useFactory: getEnvironment },
    iconsProvider(),
    provideEnvironmentNgxMask(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(APP_ROUTES, withComponentInputBinding(), withRouterConfig({ paramsInheritanceStrategy: 'always' })),
  ],
};
